const TestimonialsData = [
  {
    id: 1,
    authorName: "ommar",
    authorAvatar: "client avatar",
    text:
      "loremgh lfdgoremf fdfdlorem loregfdm loremlor hgfdgem lo remloefdhgm",
  },
  {
    id: 2,
    authorName: "shady",
    authorAvatar: "client avatar",
    text:
      "loremgh lfdgoremf fdfdlorem loregfdm loremlor hgfdgem lo remloefdhgm",
  },
  {
    id: 3,
    authorName: "fady",
    authorAvatar: "client avatar",
    text:
      "loremgh lfdgoremf fdfdlorem loregfdm loremlor hgfdgem lo remloefdhgm",
  },
  {
    id: 4,
    authorName: "magdy",
    authorAvatar: "client avatar",
    text:
      "loremgh lfdgoremf fdfdlorem loregfdm loremlor hgfdgem lo remloefdhgm",
  },
  {
    id: 5,
    authorName: "ahmed",
    authorAvatar: "client avatar",
    text:
      "loremgh lfdgoremf fdfdlorem loregfdm loremlor hgfdgem lo remloefdhgm",
  },
  {
    id: 6,
    authorName: "fwzy",
    authorAvatar: "client avatar",
    text:
      "loremgh lfdgoremf fdfdlorem loregfdm loremlor hgfdgem lo remloefdhgm",
  },
  {
    id: 7,
    authorName: "slaem",
    authorAvatar: "client avatar",
    text:
      "loremgh lfdgoremf fdfdlorem loregfdm loremlor hgfdgem lo remloefdhgm",
  },
  {
    id: 8,
    authorName: "roshdy",
    authorAvatar: "client avatar",
    text:
      "loremgh lfdgoremf fdfdlorem loregfdm loremlor hgfdgem lo remloefdhgm",
  },
];

export default TestimonialsData;
